module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"acceptTerms":"I read and accept terms and conditions","haveAccount":"Already have an account?","invitation":"You will be redirected to your invitation."},"fr":{"acceptTerms":"J\u0027ai lu et accepté les termes et conditions","haveAccount":"Vous avez déjà un compte?","invitation":"Vous serez redirigée vers votre invitation."}}')
  delete Component.options._Ctor
}
